import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';

import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTabsModule } from '@angular/material/tabs';
import { BenachrichtigungenModule } from '../../benachrichtigungen/benachrichtigungen.module';
import { MeineKontakteModule } from '../../components/meine-kontakte/meine-kontakte.module';
import { DirectivesModule } from '../../directives/directives.module';
import { OhrmarkeModule } from '../../ohrmarke/ohrmarke.module';
import { AusstallenModule } from '../ausstallen/ausstallen.module';
import { DialogsModule } from '../dialogs/dialogs.module';
import { GruppeTierCardModule } from '../gruppe-tier-card/gruppe-tier-card.module';
import { GruppeTierModule } from '../gruppe-tier/gruppe-tier.module';
import { KeyValueListModule } from '../key-value-list/key-value-list.module';
import { KieneAutocompleteModule } from '../kiene-autocomplete/kiene-autocomplete.module';
import { NumberpadModule } from '../numberpad/numberpad.module';
import { PageLayoutModule } from '../page-layout/page-layout.module';
import { PdfViewerModule } from '../pdf-viewer/pdf-viewer.module';
import { StammdatenModule } from '../stammdaten/stammdaten.module';
import { TierlistenelementModule } from '../tierlistenelement/tierlistenelement.module';
import { GruppeAbgangDialogComponent } from './gruppe-abgang-dialog/gruppe-abgang-dialog.component';
import { GruppeAbgangDownloadDialogComponent } from './gruppe-abgang-download-dialog/gruppe-abgang-download-dialog.component';
import { AbgangListeComponent } from './gruppe-abgang/abgang-liste/abgang-liste.component';
import { AbgangNumberPadComponent } from './gruppe-abgang/abgang-number-pad/abgang-number-pad.component';
import { AbgangScannenComponent } from './gruppe-abgang/abgang-scannen/abgang-scannen.component';
import { AbgangTierEingabeComponent } from './gruppe-abgang/abgang-tier-eingabe/abgang-tier-eingabe.component';
import { AbgangslisteSchliessenDialogComponent } from './gruppe-abgang/abgangsliste-schliessen-dialog/abgangsliste-schliessen-dialog.component';
import { KontaktAnlegenDialogComponent } from './gruppe-abgang/ausstallen-empfaenger-dialog/kontakt-anlegen-dialog/kontakt-anlegen-dialog.component';
import { GruppeAbgangComponent } from './gruppe-abgang/gruppe-abgang.component';
import { TierlistenauswahlDialogComponent } from './gruppe-abgang/tierlistenauswahl-dialog/tierlistenauswahl-dialog.component';
import { GruppeAnlegenDialogComponent } from './gruppe-anlegen-dialog/gruppe-anlegen-dialog.component';
import { GruppeAnlegenComponent } from './gruppe-anlegen/gruppe-anlegen.component';
import { GruppeAuswaehlenDialogComponent } from './gruppe-auswaehlen-dialog/gruppe-auswaehlen-dialog.component';
import { GruppeAuswaehlenSelektorComponent } from './gruppe-auswaehlen-selektor/gruppe-auswaehlen-selektor.component';
import { EinstallenMeldenDialogComponent } from './gruppe-einstallen/einstallen-melden-dialog/einstallen-melden-dialog.component';
import { ZugangGewichteDialogComponent } from './gruppe-einstallen/zugang-gewichte-dialog/zugang-gewichte-dialog.component';
import { EinstallenNumberPadComponent } from './gruppe-einstallen/einstallen-number-pad/einstallen-number-pad.component';
import { EinstallenTiereHinzufuegenComponent } from './gruppe-einstallen/einstallen-tiere-hinzufuegen/einstallen-tiere-hinzufuegen.component';
import { GewichtEingebenNumberpadDialogComponent } from './gruppe-einstallen/einstallen-tiere-hinzufuegen/gewicht-eingeben-numberpad-dialog/gewicht-eingeben-numberpad-dialog.component';
import { EinstallenTiereMeldenComponent } from './gruppe-einstallen/einstallen-tiere-melden/einstallen-tiere-melden.component';
import { EinstallenMobileReviewComponent } from './gruppe-einstallen/einstallen-mobile-review/einstallen-mobile-review.component';
import { EinstallenUebersichtComponent } from './gruppe-einstallen/einstallen-uebersicht/einstallen-uebersicht.component';
import { TierLoeschenConfirmDialogComponent } from './gruppe-einstallen/tier-loeschen-confirm-dialog/tier-loeschen-confirm-dialog.component';
import { TransponderNummerEingebenDialogComponent } from './gruppe-einstallen/transponder-nummer-eingeben-dialog/transponder-nummer-eingeben-dialog.component';
import { GruppeGeburtComponent } from './gruppe-geburt/gruppe-geburt.component';
import { GruppeInformationenDialogComponent } from './gruppe-kommentar-dialog/gruppe-informationen-dialog.component';
import { GruppeReklamationPdfHaendlerAuswahlDialogComponent } from './gruppe-reklamation-pdf-haendler-auswahl-dialog/gruppe-reklamation-pdf-haendler-auswahl-dialog.component';
import { EinzeltiergewichtDialogComponent } from './gruppe-standort-verwalten/einzeltiergewicht-dialog/einzeltiergewicht-dialog.component';
import { GruppeStandortVerwaltenComponent } from './gruppe-standort-verwalten/gruppe-standort-verwalten.component';
import { GruppeStandortWechselnDialogComponent } from './gruppe-standort-wechseln-dialog/gruppe-standort-wechseln-dialog.component';
import { GruppeTierHitMeldenManuellDialogComponent } from './gruppe-tier-hit-melden-manuell-dialog/gruppe-tier-hit-melden-manuell-dialog.component';
import { GruppenMenuComponent } from './gruppen-menu/gruppen-menu.component';
import { GruppenRoutingModule } from './gruppen-routing.module';
import { ImportOptionenDialogComponent } from './import-optionen-dialog/import-optionen-dialog.component';
import { AusstallenDialogComponent } from './schweine/ausstallen-dialog/ausstallen-dialog.component';
import { AusstallenUmstallenFrageDialogComponent } from './schweine/ausstallen-umstallen-frage-dialog/ausstallen-umstallen-frage-dialog.component';
import { GruppeSchweinFormComponent } from './schweine/gruppe-schwein-form/gruppe-schwein-form.component';
import { GruppeSchweineDialogComponent } from './schweine/gruppe-schweine-dialog/gruppe-schweine-dialog.component';
import { TodMeldenDialogComponent } from './schweine/tod-melden-dialog/tod-melden-dialog.component';
import { UmstallenDialogComponent } from './schweine/umstallen-dialog/umstallen-dialog.component';
import { UmstallenGruppeFrageDialogComponent } from './schweine/umstallen-gruppe-frage-dialog/umstallen-gruppe-frage-dialog.component';
import { CsvDownloadModule } from '../csv-download/csv-download.module';
import { ZeitslotBuchenDialogComponent } from './schweine/zeitslot-buchen-dialog/zeitslot-buchen-dialog.component';
import { MatListModule } from '@angular/material/list';
import { ZeitslotBuchenBottomSheetComponent } from '../gruppen/schweine/zeitslot-buchen-dialog/zeitslot-buchen-bottom-sheet/zeitslot-buchen-bottom-sheet.component';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';

@NgModule({
    declarations: [
        GruppeAbgangComponent,
        AbgangListeComponent,
        AbgangNumberPadComponent,
        AbgangScannenComponent,
        AbgangTierEingabeComponent,
        AbgangslisteSchliessenDialogComponent,
        GruppeStandortWechselnDialogComponent,
        GruppeAbgangDownloadDialogComponent,
        KontaktAnlegenDialogComponent,
        GruppeTierHitMeldenManuellDialogComponent,
        EinstallenMeldenDialogComponent,
        ZugangGewichteDialogComponent,
        EinstallenNumberPadComponent,
        EinstallenTiereHinzufuegenComponent,
        EinstallenTiereMeldenComponent,
        EinstallenMobileReviewComponent,
        EinstallenUebersichtComponent,
        TierLoeschenConfirmDialogComponent,
        TransponderNummerEingebenDialogComponent,
        GewichtEingebenNumberpadDialogComponent,
        GruppeReklamationPdfHaendlerAuswahlDialogComponent,
        TierlistenauswahlDialogComponent,
        GruppeAuswaehlenDialogComponent,
        GruppeAbgangDialogComponent,
        GruppenMenuComponent,
        GruppeInformationenDialogComponent,
        GruppeAnlegenComponent,
        GruppeAnlegenDialogComponent,
        ImportOptionenDialogComponent,
        GruppeAuswaehlenSelektorComponent,
        GruppeStandortVerwaltenComponent,
        EinzeltiergewichtDialogComponent,
        GruppeGeburtComponent,
        UmstallenDialogComponent,
        AusstallenDialogComponent,
        TodMeldenDialogComponent,
        GruppeSchweineDialogComponent,
        AusstallenUmstallenFrageDialogComponent,
        UmstallenGruppeFrageDialogComponent,
        GruppeSchweinFormComponent,
        ZeitslotBuchenDialogComponent,
        ZeitslotBuchenBottomSheetComponent,
    ],
    imports: [
        CommonModule,
        GruppenRoutingModule,
        MatButtonModule,
        MatBadgeModule,
        MatIconModule,
        KieneAutocompleteModule,
        MatFormFieldModule,
        FormsModule,
        ReactiveFormsModule,
        MatDatepickerModule,
        MatInputModule,
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
        MatRadioModule,
        MatSelectModule,
        PageLayoutModule,
        MatMenuModule,
        MatProgressSpinnerModule,
        MatTabsModule,
        GruppeTierCardModule,
        GruppeTierModule,
        OhrmarkeModule,
        MatCheckboxModule,
        MatSlideToggleModule,
        PdfViewerModule,
        BenachrichtigungenModule,
        MatDividerModule,
        MeineKontakteModule,
        MatStepperModule,
        AusstallenModule,
        TierlistenelementModule,
        CsvDownloadModule,
        DirectivesModule,
        MatCardModule,
        KeyValueListModule,
        NumberpadModule,
        StammdatenModule,
        DialogsModule,
        MatListModule,
        MatBottomSheetModule,
    ],
    exports: [
        AbgangListeComponent,
        AbgangTierEingabeComponent,
        GruppeAbgangComponent,
        GruppeStandortWechselnDialogComponent,
        GruppeAbgangDownloadDialogComponent,
        EinstallenUebersichtComponent,
        GruppeAuswaehlenDialogComponent,
        GruppeAbgangDialogComponent,
        GruppenMenuComponent,
        GruppeInformationenDialogComponent,
        GruppeAnlegenComponent,
        GruppeAuswaehlenSelektorComponent,
        GruppeStandortVerwaltenComponent,
        ImportOptionenDialogComponent,
        GruppeGeburtComponent,
        TodMeldenDialogComponent,
        UmstallenDialogComponent,
        AusstallenDialogComponent,
        GruppeSchweineDialogComponent,
        ZeitslotBuchenDialogComponent,
    ],
})
export class GruppenModule {}
